export class RecordType<T> {
  id?: T;
  description?: string = "";
  name?: string = "";
}

export class ChartType<T> {
  id?: T;
  name?: string;
  isDefault?: boolean;
}

export type BooleanKeys<T> = {
  [K in keyof T]: T[K] extends boolean ? K : never;
}[keyof T];
